export default __webpack_public_path__ + "static/media/003.e8796109.jpg";